import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { ActivityRepository } from '@domain/activity/activity.repository';
import { Activity } from '@domain/activity/activity';
import { ActivityResponseDto } from '../dtos/activity/activity.response.dto';
import { ActivityMapper } from '../mappers/activity.mapper';

@Injectable()
export class ActivityHttpRepository extends ActivityRepository {
  private readonly baseUrl = `${environment.apiUrl}/activity`;

  constructor(private readonly http: HttpClient) { super(); }

  getAll(): Observable<Activity[]> {
    return this.http.get<ActivityResponseDto[]>(this.baseUrl).pipe(
      map(dtos => dtos.map(dto => ActivityMapper.fromDto(dto)))
    );
  }

  getById(id: number): Observable<Activity> {
    return this.http.get<ActivityResponseDto>(`${this.baseUrl}/${id}`).pipe(
      map(dto => ActivityMapper.fromDto(dto))
    );
  }

  create(activity: Activity): Observable<Activity> {
    return this.http.post<ActivityResponseDto>(this.baseUrl, ActivityMapper.toRequestDto(activity)).pipe(
      map(dto => ActivityMapper.fromDto(dto))
    );
  }

  update(activity: Activity): Observable<Activity> {
    return this.http.put<ActivityResponseDto>(`${this.baseUrl}/${activity.id}`, ActivityMapper.toRequestDto(activity)).pipe(
      map(dto => ActivityMapper.fromDto(dto))
    );
  }

  deactivate(id: number): Observable<void> {
    return this.http.patch<void>(`${this.baseUrl}/${id}/toggle`, { active: false });
  }
}
